export default __webpack_public_path__ + "static/media/visby-cf.3edbcd2b.ttf";